// @flow
import { createSelector } from "reselect";
import { prop } from "ramda";

import {
  type IntegracaoExcel,
  type ModoDeBuscaDeAtivoExcel,
  type State,
} from "..";

const getIntegracaoExcel: State => IntegracaoExcel = prop("integracaoExcel");

export const getAtivoExcel: State => string = createSelector(
  getIntegracaoExcel,
  prop("ativo")
);

export const getModoDeBuscaDoAtivoExcel: State => ModoDeBuscaDeAtivoExcel = createSelector(
  getIntegracaoExcel,
  prop("modoDeBuscaDoAtivo")
);

export const getJWTExcel: State => ?string = createSelector(
  getIntegracaoExcel,
  prop("jwt")
);

export const getMedidasSuportadasExcel: State => ?Set<number> = createSelector(
  getIntegracaoExcel,
  prop("medidasSuportadas")
);
